// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editable-table table {
    width: 100%;
    border-collapse: collapse;
}

.editable-table th, .editable-table td {
    padding: 4px;
    height: 40px;
    box-sizing: content-box;
    text-align: left;
}

.editable-table td {
    border: 1px solid #ddd;
}

.editable-table .selected {
    outline: 1px solid black;
}

.editable-table input {
    width: 100%;
    height: 32px;
    box-sizing: content-box;
    outline: none;
    font: inherit;
}

.editable-table .remove-row-td {
    border-top: 1px solid #ddd;
}

.editable-table .remove-row-btn {
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
    background-color: #ff4d4f;
    color: white;
    border: none;
    border-radius: 50%;
    position: relative;
    cursor: pointer;
    font-size: 24px;
    font-weight: bold;
    padding: 0;
}

.editable-table .remove-row-btn span {
    display: inline-block;
    position: absolute;
    transform: translate(0, -7%);
}

.editable-table .remove-row-btn:hover {
    background-color: #d32f2f;
}

.editable-table .add-row-btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #76AEB7;
    color: white;
    border: none;
    border-radius: 50%;
    position: relative;
    cursor: pointer;
    font-size: 24px;
    font-weight: bold;
    padding: 0;
}

.editable-table .add-row-btn span {
    display: inline-block;
    position: absolute;
    transform: translate(0, -7%);
}

.editable-table .add-row-btn:hover {
    background-color: #4f8d96;
}`, "",{"version":3,"sources":["webpack://./src/Components/EditableTable/EditableTable.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".editable-table table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.editable-table th, .editable-table td {\r\n    padding: 4px;\r\n    height: 40px;\r\n    box-sizing: content-box;\r\n    text-align: left;\r\n}\r\n\r\n.editable-table td {\r\n    border: 1px solid #ddd;\r\n}\r\n\r\n.editable-table .selected {\r\n    outline: 1px solid black;\r\n}\r\n\r\n.editable-table input {\r\n    width: 100%;\r\n    height: 32px;\r\n    box-sizing: content-box;\r\n    outline: none;\r\n    font: inherit;\r\n}\r\n\r\n.editable-table .remove-row-td {\r\n    border-top: 1px solid #ddd;\r\n}\r\n\r\n.editable-table .remove-row-btn {\r\n    margin: auto;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 18px;\r\n    height: 18px;\r\n    background-color: #ff4d4f;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 50%;\r\n    position: relative;\r\n    cursor: pointer;\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    padding: 0;\r\n}\r\n\r\n.editable-table .remove-row-btn span {\r\n    display: inline-block;\r\n    position: absolute;\r\n    transform: translate(0, -7%);\r\n}\r\n\r\n.editable-table .remove-row-btn:hover {\r\n    background-color: #d32f2f;\r\n}\r\n\r\n.editable-table .add-row-btn {\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 30px;\r\n    height: 30px;\r\n    background-color: #76AEB7;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 50%;\r\n    position: relative;\r\n    cursor: pointer;\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    padding: 0;\r\n}\r\n\r\n.editable-table .add-row-btn span {\r\n    display: inline-block;\r\n    position: absolute;\r\n    transform: translate(0, -7%);\r\n}\r\n\r\n.editable-table .add-row-btn:hover {\r\n    background-color: #4f8d96;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
